export default __webpack_public_path__ + "static/media/tennis-platinum-cover.54cd3efd.png";